import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Button, DialogActions, DialogContent } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { withStyles } from '@material-ui/core/styles';
import ArrowRightIcon from '@material-ui/icons/ArrowForward';

import AuthUserContainer from '../../../../containers/AuthUser';
import Transition from '../../../../components/dialogs/Transition';
import FormText from '../../../../components/form/FormText';
import FormComponent from '../../../../components/FormComponent';
import { post } from '../../../../modules/utility';

import { generalStyles, groupCommodities, MobileDeliveryCommodityProduct } from '../util';
import { dialogStyles } from './dialogStyles';
import MobileDeliveryDialogSavePopup from './MobileDeliveryDialogSavePopup';

const stlBlue = '#1289d4';

const styles = () => {
	return {
		...generalStyles,
		...dialogStyles,
		scanDocumentButton: {
			fontWeight: 'bold',
			fontSize: '100%',
			//backgroundColor: stlBlue,
			//color: 'white',
			padding: `3.33vw 5.8vw`,
			lineHeight: 1,
			borderRadius: 4,
			marginTop: '1.4vw',
			//minWidth: '30vw',
		},
	};
};

class MobileDeliveryEnterProductDialog extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			isZoomOpen: false,
			hasNewScanAndHasNotSave: false,
		};
	}

	componentDidMount() {
		const { commodities } = this.props;
		if (!commodities) {
			return;
		}
		this.fillForm({ commodities });
	}

	fillForm = ({ commodities }) => {
		const commodityInfo = groupCommodities({ commodities });
		const { commoditiesByStop } = commodityInfo;

		const products = {};
		commoditiesByStop.forEach(({ commodities }) => {
			commodities.forEach((commodity) => {
				const { freightNumber, bolNumber, grossVolume, netVolume, tmwOrderId } = commodity;
				if (!products[freightNumber]) {
					products[freightNumber] = {};
				}
				products[freightNumber].tmwOrderId = tmwOrderId;
				products[freightNumber].bolNumber = bolNumber;
				products[freightNumber].grossVolume = grossVolume;
				products[freightNumber].netVolume = netVolume;
			});
		});

		return this.setState({
			products,
		});
	};

	/*
	addDevBolResource = (product) => {
		product.bolResource = {
			resourceId: 130357,
			contentType: 'image/png',
			filename: null,
			url: 'https://s3-us-west-2.amazonaws.com/sphere-dev-resources/2023830-54128-DFxbd.png',
			createdByUserId: 185,
			dateCreated: '2023-09-30T20:57:43Z',
		};
	};
	*/

	handleSubmit = () => {
		const { stopNumber, tmwOrderId } = this.props;
		const { products } = this.state;

		const formFieldError = {};
		const errors = [];

		if (!products) {
			formFieldError.products = 'Products are required';
			errors.push('Products are required');
		}

		const productUpdates = [];
		_.keys(products).forEach((freightNumber) => {
			const product = products[freightNumber];

			let grossVolume = product.grossVolume;
			if (_.isString(grossVolume) && grossVolume) {
				grossVolume = grossVolume.trim().replace(',', '');

				if (!grossVolume.match(/^\d+$/)) {
					const err = `Gross volume must be only digits.`;
					_.set(formFieldError, `products.${freightNumber}.grossVolume`, err);
					errors.push(err);
					return;
				}

				grossVolume = parseInt(grossVolume, 10);
				if (_.isNaN(grossVolume)) {
					const err = `Gross volume is an invalid number.`;
					_.set(formFieldError, `products.${freightNumber}.grossVolume`, err);
					errors.push(err);
					return;
				}
			}

			let netVolume = product.netVolume;
			if (_.isString(netVolume) && netVolume) {
				netVolume = netVolume.trim().replace(',', '');

				if (!netVolume.match(/^\d+$/)) {
					const err = `Net volume must be only digits.`;
					_.set(formFieldError, `products.${freightNumber}.netVolume`, err);
					errors.push(err);
					return;
				}

				netVolume = parseInt(netVolume, 10);
				if (_.isNaN(netVolume)) {
					const err = `Net volume is an invalid number.`;
					_.set(formFieldError, `products.${freightNumber}.netVolume`, err);
					errors.push(err);
					return;
				}
			}

			let bolNumber = product.bolNumber;
			if (_.isString(bolNumber) && bolNumber.length > 29) {
				const err = `BOL Number must be less than 30 characters.`;
				_.set(formFieldError, `products.${freightNumber}.bolNumber`, err);
				errors.push(err);
				return;
			}

			// remove all leading zeros and letters
			if (_.isString(bolNumber)) {
				bolNumber = bolNumber.replace(/^0+/, '');
				bolNumber = bolNumber.replace(/[a-zA-Z]/g, '');
			}

			productUpdates.push({
				freightNumber,
				tmwOrderId: product.tmwOrderId,
				grossVolume,
				netVolume,
				bolNumber,
			});
		});

		if (_.keys(formFieldError).length) {
			this.setState({
				formFieldError,
				isSaving: false,
				hasSavingSuccess: false,
				hasSavingError: true,
				savingError: errors.join('\n'),
			});
			return;
		}

		this.setState({ isSaving: true, formFieldError: {}, hasNewScanAndHasNotSave: false });
		post({
			method: 'tmw.deliveryTicket.updateProducts',
			params: {
				tmwOrderId,
				stopNumber,
				productUpdates,
			},
			callback: (err, r) => {
				if (err) {
					return this.setState({
						isSaving: false,
						hasSavingSuccess: false,
						hasSavingError: true,
						savingError: err,
					});
				}

				this.setState({
					isSaving: false,
					hasSavingSuccess: true,
					hasSavingError: false,
				});

				setTimeout(() => {
					this.setState({
						hasSavingSuccess: false,
					});
				}, 3000);
			},
		});
	};

	handleClose = () => {
		this.setState({
			savingSuccessful: false,
			isSaving: false,
		});
		this.props.onClose();
	};

	render() {
		const { open, classes, commodities, stopNumber, permissionMap } = this.props;
		const { isSaving, hasSavingSuccess, hasSavingError, savingError } = this.state;

		if (!commodities) {
			return (
				<Dialog
					open={open}
					TransitionComponent={Transition}
					onClose={this.handleClose}
					fullWidth={true}
					//fullScreen={true}
					scroll={'paper'}
					maxWidth={'lg'}
					classes={{
						scrollPaper: classes.dialogRoot,
						paper: classes.dialogPaper,
					}}
				>
					No commodities found on this delivery??
				</Dialog>
			);
		}

		const commodityInfo = groupCommodities({ commodities, stopNumber });
		const { commoditiesByStop } = commodityInfo;

		const showScanFeature = permissionMap ? permissionMap.canBetaBolScanning : false;

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				//fullScreen={true}
				maxWidth={'lg'}
				classes={{
					scrollPaper: classes.dialogRoot,
					paper: classes.dialogPaper,
				}}
			>
				<DialogContent
					dividers={false}
					style={{ position: 'relative' }}
					classes={{
						root: classes.dialogRoot,
					}}
				>
					<div className={classes.dialogTitle}>
						<div>Enter Product Gallons / BOL Info</div>
					</div>

					<div className={classes.productContainer}>
						{commoditiesByStop.map(({ stopSequence, commodities }) => {
							return (
								<div classes={classes.productStopGrouping} key={stopSequence}>
									{commodities.map((commodity) => {
										return this.renderCommodityForm({ commodity, showScanFeature });
									})}
								</div>
							);
						})}
					</div>
				</DialogContent>

				<DialogActions style={{ position: 'relative', backgroundColor: '#f7f7f7' }}>
					<MobileDeliveryDialogSavePopup
						classes={classes}
						isSaving={isSaving}
						hasSavingSuccess={hasSavingSuccess}
						hasSavingError={hasSavingError}
						savingError={savingError}
						savingSuccess={'Product info saved'}
					/>

					<div style={{ display: 'flex', width: '100%', padding: '0px 2vw' }}>
						<Button
							variant="contained"
							color="primary"
							aria-label="submitRackDelay"
							className={classes.dialogSubmitButton}
							onClick={this.handleSubmit}
							disabled={isSaving}
						>
							Save
						</Button>

						<Button
							variant="outlined"
							className={classes.dialogCloseButton}
							onClick={this.handleClose}
							disabled={isSaving}
						>
							Close
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		);
	}

	showZoomImageDialog = (imageSrcUrlToZoom) => {
		this.setState({ isZoomOpen: true, imageSrcUrlToZoom });
	};
	hideZoomImageDialog = () => {
		this.setState({
			imageSrcUrlToZoom: undefined,
			isZoomOpen: false,
		});
	};

	renderCommodityForm = ({ commodity, showScanFeature }) => {
		const { classes } = this.props;
		const { products } = this.state;

		const freightNumber = commodity.freightNumber;
		if (!freightNumber) {
			return <div>Commodity is missing freight number?</div>;
		}

		if (products) {
			const product = products[freightNumber];
			if (!product) {
				return <div>Commodity is missing product?</div>;
			}
		}

		const key = `${commodity.cmdCode}_${commodity.freightOrderedVolume}`;
		return (
			<div className={classes.commodityFormProductGroup} key={key}>
				<div className={classes.commodityFormProductAttribute}>
					<span className={classes.commodityFormLabel}>Product: </span>
					<span>
						<MobileDeliveryCommodityProduct cmdCode={commodity.cmdCode} /> {commodity.cmdName}
					</span>
				</div>

				<div className={classes.commodityFormProductAttribute}>
					<span className={classes.commodityFormLabel}>Supplier: </span>
					<span>{commodity.freightSupplierId}</span>
				</div>

				<div className={classes.commodityFormProductAttribute}>
					<span className={classes.commodityFormLabel}>Ordered Gallons: </span>
					<span>{commodity.freightOrderedVolume}</span>
				</div>

				<div className={classes.commodityFormProductAttribute}>
					<span className={classes.commodityFormLabel}>For Consignee: </span>
					<span>{commodity.consigneeId}</span>
				</div>

				<div className={classes.commodityFormProductInput}>
					<span>
						<ArrowRightIcon style={{ fontSize: '200%', color: stlBlue, marginTop: '1.5vw' }} />
					</span>
					<FormText
						{...this.setForm(`products.${freightNumber}.grossVolume`, 'Gross Gallons')}
						variant="outlined"
					/>
				</div>

				<div className={classes.commodityFormProductInput}>
					<span>
						<ArrowRightIcon style={{ fontSize: '200%', color: stlBlue, marginTop: '1.5vw' }} />
					</span>
					<FormText
						{...this.setForm(`products.${freightNumber}.netVolume`, 'Net Gallons')}
						variant="outlined"
					/>
				</div>
				<div className={classes.commodityFormProductInput}>
					<span>
						<ArrowRightIcon style={{ fontSize: '200%', color: stlBlue, marginTop: '1.5vw' }} />
					</span>
					<FormText
						{...this.setForm(`products.${freightNumber}.bolNumber`, 'Bol Number')}
						variant="outlined"
					/>
				</div>
				<div style={{ marginLeft: '35px' }}>
					<div style={{ marginTop: '5px' }}>
						<strong>Note:</strong> BOL number should <u>NOT</u> have leading zeros.
					</div>
					<div>
						<strong>Note:</strong> BOL number should <u>NOT</u> contain any letters.
					</div>
				</div>

				{!!showScanFeature && (
					<div className={classes.commodityFormProductInput}>
						<span>
							<ArrowRightIcon style={{ fontSize: '200%', color: stlBlue, marginTop: '3.5vw' }} />
						</span>
					</div>
				)}
			</div>
		);
	};
}

MobileDeliveryEnterProductDialog.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	classes: PropTypes.object,
	commodities: PropTypes.array.isRequired,
	stopNumber: PropTypes.number,
	tmwOrderId: PropTypes.number,
};

export default _.flow([withStyles(styles), AuthUserContainer])(MobileDeliveryEnterProductDialog);
